module.exports = __webpack_public_path__ + "img/am.3f177416.svg";